import TEXT from '../../../data/text.json';

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function validateEmail(email) {
  return EMAIL_REGEX.test(email);
}

export function validateFields(fieldNames, state) {
  return fieldNames.reduce(
    (isValid, fieldName) =>
      isValid &&
      !!state[fieldName] &&
      // If the field name is `emailValue` then test it with the email regex
      (fieldName !== 'emailValue' || EMAIL_REGEX.test(state.emailValue)) &&
      // If the field name is `images` then ensure that more than one is there
      (fieldName !== 'images' || state.images.length > 0),
    true
  );
}

export function getValidationMessage(fieldNames, state) {
  if (
    fieldNames.reduce(
      (isInvalid, fieldName) => isInvalid || !state[fieldName],
      false
    )
  ) {
    return TEXT.FORMS.fillOutAllFields;
  } else if (
    fieldNames.includes('emailValue') &&
    !EMAIL_REGEX.test(state.emailValue)
  ) {
    return TEXT.FORMS.invalidEmailAddress;
  } else if (fieldNames.includes('images') && state.images.length === 0) {
    return TEXT.FORMS.noImagesSelected;
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/formValidator.js